var React = require('react');

function Times (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m15.17 16 6.254 6.254a1.965 1.965 0 0 1 0 2.78l-1.39 1.39a1.965 1.965 0 0 1-2.78 0L11 20.17l-6.254 6.254a1.965 1.965 0 0 1-2.78 0l-1.39-1.39a1.965 1.965 0 0 1 0-2.78L6.83 16 .576 9.746a1.965 1.965 0 0 1 0-2.78l1.39-1.39a1.965 1.965 0 0 1 2.78 0L11 11.83l6.254-6.254a1.965 1.965 0 0 1 2.78 0l1.39 1.39a1.965 1.965 0 0 1 0 2.78z"}));
}

Times.defaultProps = {"viewBox":"0 0 22 32"};

module.exports = Times;

Times.default = Times;
